"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@material-ui/styles");

var _core = require("@material-ui/core");

var _ViewColumn = _interopRequireDefault(require("@material-ui/icons/ViewColumn"));

var _excluded = ["items", "anchorOrigin", "transformOrigin", "checked", "onChange", "title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    verydense: {
      paddingTop: "0px",
      paddingBottom: "0px"
    }
  };
});

var MultiSelectButton = function MultiSelectButton(props) {
  var items = props.items,
      anchorOrigin = props.anchorOrigin,
      transformOrigin = props.transformOrigin,
      checked = props.checked,
      onChange = props.onChange,
      title = props.title,
      rest = _objectWithoutProperties(props, _excluded);

  var classes = useStyles();
  var moreRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1]; //const [checked, setChecked] = useState([]);


  var handleOpen = function handleOpen() {
    setOpen(true);
  };

  var handleClose = function handleClose() {
    setOpen(false);
  };

  var handleToggle = function handleToggle(id) {
    var currentIx = checked.indexOf(id);

    var newChecked = _toConsumableArray(checked);

    if (currentIx === -1) {
      // add id to checked array
      newChecked.push(id);
    } else {
      // remove id from checked array
      newChecked.splice(currentIx, 1);
    } //setChecked(newChecked);
    // call onChange event handler


    onChange && onChange(newChecked);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.Tooltip, {
    title: title
  }, /*#__PURE__*/_react["default"].createElement(_core.IconButton, _extends({}, rest, {
    onClick: handleOpen,
    ref: moreRef,
    size: "small"
  }), /*#__PURE__*/_react["default"].createElement(_ViewColumn["default"], null))), /*#__PURE__*/_react["default"].createElement(_core.Popover, {
    anchorEl: moreRef.current,
    getContentAnchorEl: null,
    anchorOrigin: anchorOrigin,
    transformOrigin: transformOrigin,
    classes: {
      paper: classes.menu
    },
    onClose: handleClose,
    open: open
  }, /*#__PURE__*/_react["default"].createElement(_core.List, {
    dense: true,
    "aria-labelledby": "multiselect-subheader",
    subheader: /*#__PURE__*/_react["default"].createElement(_core.ListSubheader, {
      component: "div",
      id: "multiselect-subheader"
    }, title)
  }, items.map(function (i, ix) {
    var labelId = "multiselect-list-label-".concat(i.id, "-").concat(ix);
    return /*#__PURE__*/_react["default"].createElement(_core.ListItem, {
      key: ix,
      role: undefined,
      button: true,
      className: classes.verydense,
      onClick: function onClick() {
        return handleToggle(i.id);
      }
    }, /*#__PURE__*/_react["default"].createElement(_core.Checkbox, {
      checked: checked.indexOf(i.id) !== -1,
      edge: "start",
      tabIndex: -1,
      disableRipple: true,
      inputProps: {
        "aria-labelledby": labelId
      }
    }), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
      id: labelId,
      primary: i.text
    }));
  }))));
};

MultiSelectButton.propTypes = {
  items: _propTypes["default"].array.isRequired,
  anchorOrigin: _propTypes["default"].object,
  transformOrigin: _propTypes["default"].object,
  checked: _propTypes["default"].array.isRequired,
  onChange: _propTypes["default"].func,
  title: _propTypes["default"].string
};
MultiSelectButton.defaultProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "center"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "center"
  },
  items: [],
  checked: [],
  title: "Select Items"
};
var _default = MultiSelectButton;
exports["default"] = _default;